import * as actions from './actions';

const initialState = {
    error: null,
    initial: false,
    loading: false,
    categories: [],
};

export default function categoriesReducer(state = initialState, action) {
    switch (action.type) {
        // fetch
        case actions.FETCH_CATEGORIES.REQUEST:
            return { ...state, error: null, loading: true };

        case actions.FETCH_CATEGORIES.SUCCESS: {
            return { ...state, initial: true, categories: action.payload, loading: false };
        }

        case actions.FETCH_CATEGORIES.FAILURE:
            return { ...state, initial: false, error: action.payload, loading: false };

        default:
            return state;
    }
}